import { useState } from 'react';
import { useSelector } from 'react-redux';

import { status } from 'constants/general';
import membersStrings from 'modules/members/strings';
import Modal from 'modules/common/components/Modal';
import UpdateUserStatusForm from 'modules/members/components/UpdateUserStatusForm';
import Loader from 'modules/common/components/Loader';

import { Button, BlockIcon, UnblockIcon } from './UpdateUserStatusButton.style';

const { blockUser, unblockUser } = membersStrings.memberProfile;

const UpdateUserStatusButton = () => {
  const [isModalHidden, setIsModalHidden] = useState(true);

  const { member } = useSelector(state => state.members);
  const { details, blockingStatus } = member;
  const { isBlocked } = details.data;

  const isLoading = blockingStatus === status.FETCHING;

  const closeModal = () => {
    setIsModalHidden(true);
  };

  const renderBtnText = () =>
    isBlocked ? (
      <>
        <UnblockIcon /> {unblockUser}
      </>
    ) : (
      <>
        <BlockIcon /> {blockUser}
      </>
    );

  return (
    <>
      <Modal
        isModalHidden={isModalHidden}
        onCloseModal={() => {
          setIsModalHidden(true);
        }}
      >
        <UpdateUserStatusForm closeModal={closeModal} />
      </Modal>
      <Button
        type="button"
        onClick={() => {
          setIsModalHidden(false);
        }}
      >
        {isLoading ? <Loader width={10} height={10} thickness={5} /> : renderBtnText()}
      </Button>
    </>
  );
};

UpdateUserStatusButton.propTypes = {};

UpdateUserStatusButton.defaultProps = {};

export default UpdateUserStatusButton;
